export const flatten = (data: any) =>
    data.reduce((acc: any, item: any) => {
        if (item.children) {
            return [...acc, item, ...flatten(item.children)]
        }
        return [...acc, item]
    }, []);


export const findObject = (data: any, name: any) => data.find((searchedName: any) => searchedName.name === name)

